
export {ICUMessageFormatter} from "./icu-message-formatter"
export type {Currencies} from "./types/currencies"
export type {Culture} from "./types/cultures"
export {CultureCodes, Cultures, CulturesInTheirLanguages} from "./types/cultures"
import type {Culture} from "./types/cultures"
import { CultureCodes, Cultures } from "./types/cultures"
export function isCulture(possibleCulture: string): possibleCulture is Culture {
    return CultureCodes.includes(possibleCulture as any)
}

export const PseudoCultures: Culture[] = [Cultures.MicroCodeEnglish, Cultures.StretchEnglish];
export function isPseudoCulture(culture: Culture): boolean {
    return PseudoCultures.includes(culture)
} 

export type KeyValuePairs = {
    [key: string]: string
  }
  
export type CultureKeyValuePairs = {
    [culture in Culture]: KeyValuePairs
  }